export default [
  'el-checkbox__original',
  'el-input__inner',
  'el-textarea__inner'
]



// WEBPACK FOOTER //
// ./src/utils/validElementFormInputs.js